import { render, staticRenderFns } from "./ActivityFeed.vue?vue&type=template&id=113009e1&scoped=true&"
import script from "./ActivityFeed.vue?vue&type=script&lang=js&"
export * from "./ActivityFeed.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFeed.vue?vue&type=style&index=0&id=113009e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113009e1",
  null
  
)

export default component.exports